/**
 * 크레딧 — 크레딧 단위 라벨 상수
 *
 *  추후 단위명이 변경될 때 (예: "크레딧" → "멍콩" / "도토리" / "뼈다귀")
 *  이 파일 한 곳만 바꾸면 전 화면 라벨이 일괄 갱신됩니다.
 *  DB 컬럼명·API 응답 필드명은 도메인 중립어로 유지 (BALANCE / AMOUNT 등).
 */

export const CREDIT = {
  /** 단위명 — 메인 라벨 */
  unit: "크레딧",
  /** 단위명 — 짧은 표기 (UI 협소 공간) */
  unitShort: "크레딧",
  /** 지갑 이름 */
  walletName: "크레딧",
  /** 단위 이모지 — 강아지 간식 시그니처 (뼈다귀).
   *  추후 자체 SVG 일러스트로 교체 시 이 한 줄만 바꾸면 전 화면 일괄 갱신. */
  emoji: "🦴",
  /** 환급/지급 시 강조 이모지 */
  emojiBonus: "💚",
  /** 장식용 보조 이모지 — 주머니에서 살짝 삐져나오는 간식 */
  emojiPeek: "🍪",
  /** 액션 단어 */
  actions: {
    charge: "충전",
    use: "사용",
    grant: "지급",
    refund: "환급",
  },
} as const;

/** 트랜잭션 타입별 사장님 표시용 한글 라벨 */
export const CREDIT_TX_LABEL: Record<string, { label: string; emoji: string }> = {
  // 지급
  GRANT_SIGNUP:            { label: "신규 가입 무료",    emoji: "🎁" },
  GRANT_MONTHLY_FREE:      { label: "이번 달 무료 지급", emoji: "🎁" },
  GRANT_PROMOTION:         { label: "프로모션",          emoji: "🎉" },
  GRANT_REFERRAL:          { label: "추천 가입 보상",    emoji: "🤝" },
  PURCHASE:                { label: "크레딧 충전",       emoji: "💳" },
  REFUND_PAYMENT_FEE:      { label: "결제 환급",         emoji: "💚" },
  ADMIN_ADJUSTMENT:        { label: "관리자 조정",       emoji: "⚙" },

  // 차감
  USE_AI_DIARY_TEXT:       { label: "AI 알림장 (텍스트)",emoji: "🪄" },
  USE_AI_DIARY_PHOTO:      { label: "AI 알림장 (사진)",  emoji: "🪄" },
  USE_AI_DIARY_VIDEO:      { label: "AI 알림장 (영상)",  emoji: "🪄" },
  USE_AI_DIARY_REGEN:      { label: "AI 알림장 재생성",  emoji: "🔄" },
  USE_TICKET_OFFLINE:      { label: "이용권 수동 발급",  emoji: "🎟" },
  USE_SMS:                 { label: "SMS 발송",          emoji: "💌" },
  USE_KAKAO_ALIM:          { label: "알림톡 발송",       emoji: "📨" },
  USE_CONTRACT_PUSH:       { label: "계약서 푸시",       emoji: "📋" },
  USE_PHOTO_BACKUP:        { label: "사진 백업",         emoji: "💾" },
  EXPIRE_FREE:             { label: "무료분 만료",       emoji: "⌛" },
  REFUND_TO_USER:          { label: "환불",              emoji: "💵" },

  // 되돌림 — 이용권 회수 시 발급 차감분이 되돌아옴 (CREDIT 방향, 사용내역에 함께 노출)
  REFUND_TICKET_REVOKE:    { label: "이용권 회수 환원",  emoji: "↩️" },
  REVERSAL:                { label: "지급 회수",         emoji: "↩️" },
};

/** 잔액 레벨 분류 — 헤더 칩 색상·임계치 정책 */
export const CREDIT_THRESHOLDS = {
  /** 이 이상이면 정상 (오렌지) */
  ok: 100,
  /** 이 미만이면 경고 (노랑) */
  warn: 10,
  /** 이 미만이면 위험 (빨강) */
  low: 0,
} as const;

export type CreditLevel = "ok" | "warn" | "low";

export const getCreditLevel = (balance: number): CreditLevel => {
  if (balance >= CREDIT_THRESHOLDS.ok) return "ok";
  if (balance >= CREDIT_THRESHOLDS.warn) return "warn";
  return "low";
};
